export default __webpack_public_path__ + "static/media/hero.e08a247d.jpg";